import { render, staticRenderFns } from "./DiggButton.vue?vue&type=template&id=d45147ea&scoped=true&"
import script from "./DiggButton.vue?vue&type=script&lang=js&"
export * from "./DiggButton.vue?vue&type=script&lang=js&"
import style0 from "./DiggButton.vue?vue&type=style&index=0&id=d45147ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45147ea",
  null
  
)

export default component.exports